export default {"src":"/_next/static/media/slide-prev.380af452.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};